<!--title -->
<app-modal-title
  [title]="formPageConfig.title | translate"
  [isShowClose]="true"
  (isCloseModal)="onClose()"
></app-modal-title>

<div mat-dialog-content class="dialog-content">
  <!-- form -->
  <form [formGroup]="form" autocomplete="off">
    <div class="tw-flex-center flex-column">
      <!-- senderNumberId -->
      <div class="tw-w-[300px]">
        <enum-select-search
          class="tw-w-full"
          enumName="VoiceStatus"
          label="common.status"
          [control]="form?.get('status')"
          [(value)]="model.status"
          (onError)="onClose()"
        >
        </enum-select-search>
      </div>
    </div>

    <!-- submit btn -->
    <button
      type="button"
      (click)="onSubmit()"
      mat-ripple
      class="btn tw-w-full tw-mt-3 button-shadow btn-hover-rise"
      [disabled]="loading"
      [themeColor]="'btn'"
    >
      <ng-container *ngIf="!loading">
        <span>{{ "common.edit" | translate }}</span>
      </ng-container>

      <!-- loading -->
      <ng-container *ngIf="loading">
        <span
          class="spinner-border spinner-border-sm"
          role="status"
          aria-hidden="true"
        ></span>
        <span class="sr-only">Loading...</span>
      </ng-container>
    </button>
  </form>
</div>
